module.exports = __webpack_public_path__ + "img/GAME_FLAG.9cf48f81.jpg";